import { Route, Routes } from "react-router-dom";
import LoginPage from "@/pages/LoginPage";
import NotFoundPage from "@/pages/NotFoundPage";
import ReportPage from "@/pages/RecordsPage";
import { ProtectedRoute } from "./protectedRoute";
import { PATH } from "./path.constant";
import AllocationPage from "@/pages/AllocationPage";
import AllocationDetailPage from "@/pages/AllocationPage/allocationDetailPage";
import { ProtectedRoleRoute } from "@/router/protectedRoleRoute";
import UploadPage from "@/pages/UploadPage";
import ExportPage from "@/pages/ExportPage";
import SettingsPage from "@/pages/SettingsPage";
import ResultPage from "@/pages/ResultPage";
import TripSummaryPage from "@/pages/TripSummary";
import TripDetailPage from "@/pages/TripDetail";
import BusDetailPage from "@/pages/BusDetail";
import DashboardPage from "@/pages/Dashboard";
import BasicLayout from "@/pages/Layout";

export const AppRoutes = () => {
	return (
		<Routes>
			<Route path={PATH.login.path} element={<LoginPage />} />
			<Route
				path={PATH.home.path}
				element={
					<ProtectedRoute>
						<BasicLayout />
					</ProtectedRoute>
				}
			>
				<Route
					path={PATH.home.path}
					element={
						<ProtectedRoleRoute
							allowedRoles={PATH.home.allowedRole}
						>
							<DashboardPage />
						</ProtectedRoleRoute>
					}
				/>
				<Route
					path={PATH.record.path}
					element={
						<ProtectedRoleRoute
							allowedRoles={PATH.record.allowedRole}
						>
							<ReportPage />
						</ProtectedRoleRoute>
					}
				/>
				<Route
					path={PATH.allocation.path}
					element={
						<ProtectedRoleRoute
							allowedRoles={PATH.allocation.allowedRole}
						>
							<AllocationPage />
						</ProtectedRoleRoute>
					}
				/>
				<Route
					path={PATH.allocationDetail.path}
					element={
						<ProtectedRoleRoute
							allowedRoles={PATH.allocationDetail.allowedRole}
						>
							<AllocationDetailPage />
						</ProtectedRoleRoute>
					}
				/>
				<Route
					path={PATH.upload.path}
					element={
						<ProtectedRoleRoute
							allowedRoles={PATH.upload.allowedRole}
						>
							<UploadPage />
						</ProtectedRoleRoute>
					}
				/>
				<Route
					path={PATH.export.path}
					element={
						<ProtectedRoleRoute
							allowedRoles={PATH.export.allowedRole}
						>
							<ExportPage />
						</ProtectedRoleRoute>
					}
				/>
				<Route
					path={PATH.settings.path}
					element={
						<ProtectedRoleRoute
							allowedRoles={PATH.settings.allowedRole}
						>
							<SettingsPage />
						</ProtectedRoleRoute>
					}
				/>
				<Route
					path={PATH.result.path}
					element={
						<ProtectedRoleRoute
							allowedRoles={PATH.result.allowedRole}
						>
							<ResultPage />
						</ProtectedRoleRoute>
					}
				/>
			</Route>
			<Route path={PATH.tripSummary.path} element={<TripSummaryPage />} />
			<Route path={PATH.tripDetail.path} element={<TripDetailPage />} />
			<Route path={PATH.busDetail.path} element={<BusDetailPage />} />
			<Route path="*" element={<NotFoundPage />} />
		</Routes>
	);
};
